<mat-form-field [ngStyle]="styles" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [matAutocomplete]="auto"
    type="text"
    [formControl]="control"
    (focus)="onShowSuggestions(control.value ?? '')" />
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete">
  @for (suggestion of suggestions; track suggestion) {
    <mat-option [value]="suggestion">
      {{ suggestion }}
    </mat-option>
  }
</mat-autocomplete>
